export default __webpack_public_path__ + "static/media/thumb-redeem-success.c49e1059.png";